import React from 'react';
import { Box, Container, Typography, Link, Stack, Divider } from '@mui/material';

const COMPANY = 'Unidatum Integrated Products Limited';

/** Site footer: copyright + legal links (Terms, Privacy with EU/US sections). */
const Footer: React.FC = () => {
  const year = new Date().getFullYear();
  return (
    <Box
      component="footer"
      sx={{
        mt: 6,
        py: 3,
        borderTop: '1px solid',
        borderColor: 'divider',
      }}
    >
      <Container maxWidth="lg">
        <Stack
          direction={{ xs: 'column', sm: 'row' }}
          spacing={1.5}
          justifyContent="space-between"
          alignItems="center"
        >
          <Typography variant="body2" color="text.secondary">
            © {year} {COMPANY}. All rights reserved.
          </Typography>
          <Stack
            direction="row"
            spacing={1.5}
            flexWrap="wrap"
            useFlexGap
            justifyContent="center"
            divider={<Divider orientation="vertical" flexItem />}
          >
            <Link href="/ats-score" color="primary" underline="hover" variant="body2">
              Free ATS Score
            </Link>
            <Link href="/guides/" color="primary" underline="hover" variant="body2">
              Job Search Help
            </Link>
            <Link href="/projects/" color="primary" underline="hover" variant="body2">
              Resume Projects
            </Link>
            <Link href="/blog/" color="primary" underline="hover" variant="body2">
              Blog
            </Link>
            <Link href="/ats/" color="primary" underline="hover" variant="body2">
              ATS Guides
            </Link>
            <Link href="/resume-keywords/" color="primary" underline="hover" variant="body2">
              Resume Keywords
            </Link>
            <Link href="/resume-synonyms/" color="primary" underline="hover" variant="body2">
              Resume Synonyms
            </Link>
            <Link href="/engineering/" color="primary" underline="hover" variant="body2">
              Engineering
            </Link>
            <Link href="/terms" color="primary" underline="hover" variant="body2">
              Terms of Use
            </Link>
            <Link href="/privacy" color="primary" underline="hover" variant="body2">
              Privacy Policy
            </Link>
            <Link href="/privacy#eu" color="primary" underline="hover" variant="body2">
              EU/UK (GDPR)
            </Link>
            <Link href="/privacy#us" color="primary" underline="hover" variant="body2">
              US (CCPA)
            </Link>
          </Stack>
        </Stack>
      </Container>
    </Box>
  );
};

export default Footer;
